import { type OperationResponse, type Parameters } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

interface OperationMethods {
  "setDefaultLanguage"(
    parameters?: Parameters<Paths.SetDefaultLanguage.PathParameters> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.SetDefaultLanguage.Responses.$204>;
}

export const getLanguageOperations = (client: AxiosInstance) => {
  const setDefaultLanguage: OperationMethods["setDefaultLanguage"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/language/{id}/set-default";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    setDefaultLanguage,
  };
};
